import { QUIZ } from '~/consts';

export const shuffleQuestions = (_quiz) => {
  const quiz = { ..._quiz };
  let questions = { ...quiz.questions };

  questions = collect(questions)
    .shuffle()
    .map((_field, fieldIndex) => {
      const field = { ..._field };
      field.order = fieldIndex;

      return field;
    })
    .toArray();

  quiz.questions = questions;

  return quiz;
};

export default async function ({ store, $axios, redirect, params, query, route }) {
  try {
    const { data } = await $axios.post(QUIZ.IS_DONE(params.uuid, query.quizMemberUuid));

    if (helpers.isEmpty(data.data.lastSubmittedAt) || (query.success == 1)) {
      const { data } = await $axios.post(QUIZ.RUNNING_QUIZ(params.uuid, query.quizMemberUuid));
      let data_res = data.data;

      if (data.applicationSystem.code == 0 && !helpers.isEmpty(data_res)) {
        if (data_res.shuffleQuestions === true) {
          data_res = shuffleQuestions(data_res);
        }

        store.commit('quizes/setRunnedQuiz', data_res);
      } else {
        return redirect('/panel');
      }
    } else {
      return redirect({path: route.path, query: { quizMemberUuid: query.quizMemberUuid, success: 1 }});
    }
  } catch (e) {
    return redirect('/panel');
  }
}
